/* Strict mode is used for development purpose only and should be removed in production mode.
    But it is cause some bugs in development mode that's why we disabled it by default.
    If anyone want to used set it true */
export const useStrictMode = false;

export const GOOGLE_CLOUD_API_KEY = process.env.REACT_APP_GOOGLE_CLOUD_API_KEY;
export const DEFAULT_MAP_POSITION = { 
    lat: parseFloat(process.env.REACT_APP_DEFAULT_MAP_LAT) || 29.761291, 
    lng: parseFloat(process.env.REACT_APP_DEFAULT_MAP_LNG) || -95.362869 
};
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY

console.log(STRIPE_PUBLIC_KEY)

export const LOAD_TYPES = {
    "USA": [
        {
            value: "vehicle",
            label: "Vehicle",
        },
        {
            value: "pallet",
            label: "Pallet",
        },
        {
            value: "barrel",
            label: "Barrel",
        }
    ],
    "Ghana": [
        {
            value: "stones",
            label: "Stones",
        },
        {
            value: "sand",
            label: "Sand",
        },
        {
            value: "laterite",
            label: "Laterite",
        },
    ],
    "Nigeria": [
        {
            value: "stones",
            label: "Stones",
        },
        {
            value: "sand",
            label: "Sand",
        },
        {
            value: "laterite",
            label: "Laterite",
        },
    ]
}

